/**
 * External dependencies
 */
import React from 'react';
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import NavListItem from './nav-list-item';
import NavListLink from './nav-list-link';

/**
 * Style dependencies
 */
import './styles.scss';

const NavList = ({ children }) => {
	const classes = classnames('nav-list');

	return <ul className={classes}>{children}</ul>;
};

NavList.NavListItem = NavListItem;
NavList.NavListLink = NavListLink;

export default NavList;
